import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateUserProfilesMutation, UpdateUserProfilesMutationVariables } from '@/graphql/generated/graphql';
import { UpdateUserProfilesDocument } from '@/graphql/generated/graphql';
export type UserProfileUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  BlocksUserId?: string
  JobTitle?: string
  Department?: string
  OnboardingCompleted?: boolean
  OnboardingCompletedAt?: string
  OnboardingStepsCompleted?: string[]
}

export type UpdateUserProfileResponse = {
  data: {
    updateUserProfiles: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateUserProfile = () => {
  const mutation = useMutation({
    mutationKey: ['update-user-profile'],
    mutationFn: (variables: UserProfileUpdateInput) => {
      return graphqlClient.request<UpdateUserProfilesMutation>(UpdateUserProfilesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateUserProfile: mutation.mutate,
    updateUserProfileAsync: mutation.mutateAsync,
  }
}

export const UPDATE_USER_PROFILE_MUTATION = UpdateUserProfilesDocument;
